var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 256 256",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m58 38h140v180h-140z",
    fill: "#a4c9ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m58 24v14h140v-14c0-8.837-7.163-16-16-16h-108c-8.837 0-16 7.163-16 16z",
    fill: "#4671c6",
    style: {
      fill: "rgb(41, 111, 205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198 232v-14h-140v14c0 8.837 7.163 16 16 16h108c8.837 0 16-7.163 16-16z",
    fill: "#4671c6",
    style: {
      fill: "rgb(41, 111, 205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 250h-108c-9.925 0-18-8.075-18-18v-208c0-9.925 8.075-18 18-18h108c9.925 0 18 8.075 18 18v208c0 9.925-8.075 18-18 18zm-108-240c-7.72 0-14 6.28-14 14v208c0 7.72 6.28 14 14 14h108c7.72 0 14-6.28 14-14v-208c0-7.72-6.28-14-14-14z",
    fill: "#3762cc",
    style: {
      fill: "rgb(55, 103, 225)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 241h-24c-3.314 0-6-2.686-6-6v-4c0-3.314 2.686-6 6-6h24c3.314 0 6 2.686 6 6v4c0 3.314-2.686 6-6 6z",
    fill: "#6bdddd",
    style: {
      fill: "rgb(211, 223, 223)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m143 28h-30c-2.761 0-5-2.239-5-5 0-2.761 2.239-5 5-5h30c2.761 0 5 2.239 5 5 0 2.761-2.239 5-5 5z",
    fill: "#e0ebfc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m198 40h-140c-1.104 0-2-.896-2-2v-14c0-9.925 8.075-18 18-18h108c9.925 0 18 8.075 18 18v14c0 1.104-.896 2-2 2zm-138-4h136v-12c0-7.72-6.28-14-14-14h-108c-7.72 0-14 6.28-14 14z",
    fill: "#3762cc",
    style: {
      fill: "rgb(55, 103, 225)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 250h-108c-9.925 0-18-8.075-18-18v-14c0-1.104.896-2 2-2h140c1.104 0 2 .896 2 2v14c0 9.925-8.075 18-18 18zm-122-30v12c0 7.72 6.28 14 14 14h108c7.72 0 14-6.28 14-14v-12z",
    fill: "#3762cc",
    style: {
      fill: "rgb(55, 103, 225)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182 250h-108c-9.925 0-18-8.075-18-18v-208c0-9.925 8.075-18 18-18h108c9.925 0 18 8.075 18 18v208c0 9.925-8.075 18-18 18zm-108-240c-7.72 0-14 6.28-14 14v208c0 7.72 6.28 14 14 14h108c7.72 0 14-6.28 14-14v-208c0-7.72-6.28-14-14-14z",
    fill: "#3762cc",
    style: {
      fill: "rgb(55, 103, 225)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffea92"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 147.138,
    cy: 96.811,
    r: 21.349,
    fill: "#ffea92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.138 71.773c-1.107 0-2.005-.898-2.005-2.005v-11.03c0-1.108.898-2.005 2.005-2.005 1.108 0 2.005.898 2.005 2.005v11.029c0 1.108-.898 2.006-2.005 2.006z",
    fill: "#ffea92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.138 136.89c-1.107 0-2.005-.898-2.005-2.005v-11.029c0-1.107.898-2.005 2.005-2.005 1.108 0 2.005.898 2.005 2.005v11.029c0 1.107-.898 2.005-2.005 2.005z",
    fill: "#ffea92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.177 96.811c0-1.108.898-2.005 2.005-2.005h11.029c1.108 0 2.005.898 2.005 2.005 0 1.107-.898 2.005-2.005 2.005h-11.029c-1.108.001-2.005-.897-2.005-2.005z",
    fill: "#ffea92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.06 96.811c0-1.108.898-2.005 2.005-2.005h11.029c1.107 0 2.005.898 2.005 2.005 0 1.107-.898 2.005-2.005 2.005h-11.029c-1.108.001-2.005-.897-2.005-2.005z",
    fill: "#ffea92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.843 114.516c.783-.783 2.053-.783 2.836 0l7.799 7.799c.783.783.783 2.053 0 2.836-.783.783-2.053.783-2.836 0l-7.799-7.799c-.783-.783-.783-2.053 0-2.836z",
    fill: "#ffea92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.798 68.472c.783-.783 2.053-.783 2.836 0l7.799 7.799c.783.783.783 2.053 0 2.836-.783.783-2.053.783-2.836 0l-7.799-7.799c-.783-.784-.783-2.053 0-2.836z",
    fill: "#ffea92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.433 114.516c.783.783.783 2.053 0 2.836l-7.799 7.799c-.783.783-2.053.783-2.836 0-.783-.783-.783-2.053 0-2.836l7.799-7.799c.783-.783 2.053-.783 2.836 0z",
    fill: "#ffea92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.478 68.472c.783.783.783 2.053 0 2.836l-7.799 7.799c-.783.783-2.053.783-2.836 0-.783-.783-.783-2.053 0-2.836l7.799-7.799c.783-.784 2.053-.784 2.836 0z",
    fill: "#ffea92"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m148.269 115.025h-.565c-.443-8.932-7.825-16.039-16.867-16.039-1.948 0-3.817.334-5.558.941-2.156-7.491-9.056-12.974-17.241-12.974-9.91 0-17.944 8.034-17.944 17.944 0 .703.045 1.394.123 2.076-9.837 1.285-17.434 9.692-17.434 19.879 0 11.076 8.979 20.055 20.055 20.055h55.431c8.804 0 15.941-7.137 15.941-15.941 0-8.804-7.137-15.941-15.941-15.941z",
    fill: "#e0ebfc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m148.882 190.196h-41.763c-4.652 0-8.423-3.771-8.423-8.423v-9.125c0-4.652 3.771-8.423 8.423-8.423h41.763c4.652 0 8.423 3.771 8.423 8.423v9.125c0 4.652-3.771 8.423-8.423 8.423z",
    fill: "#f9a7a7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m107.118 185.196c-1.887 0-3.423-1.535-3.423-3.423v-9.125c0-1.888 1.536-3.423 3.423-3.423h41.764c1.888 0 3.423 1.535 3.423 3.423v9.125c0 1.888-1.535 3.423-3.423 3.423z",
    fill: "#f9cfcf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAndroid);
export default __webpack_public_path__ + "static/media/iconAndroid.1b3c2a5cefe8052ca1f41ae88631e3c2.svg";
export { ForwardRef as ReactComponent };